/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const DURATIONS = {
    slow: 14000,
    medium: 10000,
    fast: 6000,
};
export const SLOTS = {
    actionsEnd: "actions-end",
    title: "title",
    message: "message",
    link: "link",
};
export const CSS = {
    actionsEnd: "actions-end",
    close: "close",
    container: "container",
    containerBottom: "container--bottom",
    containerBottomEnd: "container--bottom-end",
    containerBottomStart: "container--bottom-start",
    containerActive: "container--active",
    containerTop: "container--top",
    containerTopEnd: "container--top-end",
    containerTopStart: "container--top-start",
    content: "content",
    contentContainer: "content-container",
    dismissProgress: "dismiss-progress",
    footer: "footer",
    icon: "icon",
    containerEmbedded: "container--embedded",
    queueCount: "queue-count",
    queueCountActive: "queue-count--active",
    textContainer: "text-container",
    focused: "focused",
};
//# sourceMappingURL=resources.js.map
